import { render, staticRenderFns } from "./CellModal.vue?vue&type=template&id=0b0fbff6&"
import script from "./CellModal.vue?vue&type=script&lang=js&"
export * from "./CellModal.vue?vue&type=script&lang=js&"
import style0 from "./CellModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports